export const version = "ethers/5.4.4";
//# sourceMappingURL=_version.js.map